// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'

import router from './router'
import axios from 'axios'
import store, { http } from './store/store'
import VueSession from 'vue-session';
import underscore from 'vue-underscore'
import 'expose-loader?$!expose-loader?jQuery!jquery'
import jQuery from 'jquery'
import VTooltip from 'v-tooltip'
import draggable from 'vuedraggable'
import swal from 'sweetalert2'

window.jQuery = jQuery;

Vue.use(jQuery);

Vue.use(BootstrapVue);
Vue.use(VueSession);
Vue.use(underscore);
Vue.use(VTooltip);
Vue.use(draggable);

//---- 전역 필터 설정 by.guidda ----
// 숫자 자리수 콤마 설정
Vue.filter('numberComma', function (val) {
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});
// 핸드폰번호 정규식
Vue.filter('phoneNumberRegx', function (val) {
  if (val != null && val.length > 0) {
    return String(val).replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  } else {
    return '';
  }
});
//---- 전역 필터 설정 by.guidda ----

// input 숫자만 입력 받기
Vue.directive('numbers-only', {
  bind(el) {
    el.addEventListener('input', function (e) {
      const input = e.target;
      const regex = /[^0-9]/g;
      input.value = input.value.replace(regex, '');
    });
  }
});


// 요청 인터셉터: 모든 API 요청에 토큰 자동 추가
http.interceptors.request.use(
  config => {
    // 로그인 관련 요청은 이미 Authorization 헤더가 설정되어 있으므로 건너뜀
    const isAuthRequest = config.url && (
      config.url.includes('/oauth/token') 
      || config.url.includes('/oauth/check_token')
      || config.url.includes('/login')
      //  || config.url.includes('/select/user')  // 로그인 과정에서 유저 정보 조회
    );
    
    // Authorization 헤더가 이미 설정되어 있으면 건너뜀 (Basic Auth 등)
    const hasAuthHeader = config.headers && config.headers.Authorization;
    
    if (!isAuthRequest && !hasAuthHeader) {
      const token = sessionStorage.getItem("myToken");
      console.log('token : ', token);
      if (token && token !== "null") {
        config.headers.Authorization = `Bearer ${token}`;
        console.log('[Axios] 토큰 추가:', token.substring(0, 20) + '...');
      } else {
        console.log('[Axios] 토큰 없음');
      }
    } else {
      console.log('[Axios] 인증 요청 건너뜀 - URL:', config.url);
    }
    
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 401 에러 처리 중복 방지 플래그
let isHandling401 = false;

// 응답 인터셉터 설정
http.interceptors.response.use(
  response => {
    // console.log('response : ', response);
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      const errorData = error.response.data;
      const requestUrl = (error.config && error.config.url) ? error.config.url : '';
      
      // 로그인 관련 요청의 401 에러는 컴포넌트에서 처리하도록 패스
      const isLoginRequest = requestUrl.includes('/login') || 
                             requestUrl.includes('/oauth/token') || 
                             requestUrl.includes('/select/user');
      
      if (isLoginRequest) {
        // 로그인 페이지에서 발생한 401 에러는 그냥 전달
        return Promise.reject(error);
      }

      // 이미 401 에러를 처리 중이면 중복 alert 방지
      if (isHandling401) {
        console.log('[Axios] 401 에러 처리 중 - 중복 방지');
        return Promise.reject(error);
      }

      // 401 에러 처리 시작
      isHandling401 = true;
      console.log('[Axios] 401 에러 처리 시작');

      // 세션 정리 공통 처리
      var cleanupSession = function() {
        if (window.vm && window.vm.$session) {
          window.vm.$session.destroy();
        }
        store.dispatch('LOGOUT');
        
        // 플래그 리셋 (1초 후)
        setTimeout(function() {
          isHandling401 = false;
          console.log('[Axios] 401 에러 처리 플래그 리셋');
        }, 1000);
      };

      // 중복 로그인으로 인한 세션 종료
      if (errorData.error === 'duplicate_login') {
        swal.fire({
          type: 'error',
          title: '다른 곳에서 로그인하여 현재 세션이 종료되었습니다.',
          showConfirmButton: false,
          timer: 1500
        });
        
        cleanupSession();
        
        // 로그인 페이지로 이동
        router.push('/pages/login').catch(function(err) {
          console.log('Router push error:', err);
        });
      }
      // 토큰 만료
      else if (errorData.error === 'token_expired') {
        swal.fire({
          type: 'error',
          title: '토큰이 만료되었습니다. 다시 로그인해주세요.',
          showConfirmButton: false,
          timer: 1500
        });
        cleanupSession();
        
        // 로그인 페이지로 이동
        router.push('/pages/login').catch(function(err) {
          console.log('Router push error:', err);
        });
      }
      // 일반 인증 오류 (백엔드가 명시적인 에러 코드를 보내지 않은 경우)
      else {
        console.log('[Axios] 일반 401 에러 - errorData:', errorData);
        alert('인증이 필요합니다. 다시 로그인해주세요.');
        cleanupSession();
        
        // 로그인 페이지로 이동
        router.push('/pages/login').catch(function(err) {
          console.log('Router push error:', err);
        });
      }
    }

    return Promise.reject(error);
  }
);



/* eslint-disable no-new */
/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js